window.addEventListener('load', () => {
  const dropdowns = document.querySelectorAll(".localisation-dropdown-selector");
  
  function handleLocalisationChange() {
    dropdowns.forEach((dropdown) => {
      dropdown.selectedIndex = "0";
    });
  }

  handleLocalisationChange();
})

window.addEventListener("DOMContentLoaded", () => {
  // The mobile gallery renders a fullscreen button + video per mp4 slide, so we
  // can't target a single element by id - resolve the video next to whichever
  // button was tapped (falling back to the first one for the desktop gallery).
  function getProductVideoFromButton(button) {
    let videoWrapper = button.closest(".product__video-wrapper");
    return videoWrapper ? videoWrapper.querySelector(".product__video") : document.querySelector(".product__video");
  }

  function fullscreenifyProductVideo(productVideo) {
    if (!productVideo) {
      return;
    }

    if (productVideo.requestFullscreen) {
      productVideo.requestFullscreen();
    } else if (productVideo.mozRequestFullScreen) { // Firefox
      productVideo.mozRequestFullScreen();
    } else if (productVideo.webkitRequestFullscreen) { // Chromium and macOS Safari
      productVideo.webkitRequestFullscreen();
    } else if (productVideo.webkitSupportsFullscreen) { // iOS Safari
      productVideo.webkitEnterFullscreen();
    }
  }

  document.addEventListener("click", (event) => {
    let vidFullScreenBtn = event.target.closest("#video-fullscreen-button");

    if (!vidFullScreenBtn) {
      return;
    }

    fullscreenifyProductVideo(getProductVideoFromButton(vidFullScreenBtn));
  });
})

/*Remove Z size from Popup*/
jQuery(document).ready(function () {
    //console.log('LOAD');
    let optionRemove = false;
    jQuery('body').on('click', '.product-single__form .back-stock-btn', function () {
        //console.log('CLICK');
        if (!optionRemove) {
            jQuery('#BIS_frame').contents().find('#variants option:first-child').remove();
            optionRemove = true;
        }
    });
  
  
  if (jQuery('.slider-404').length) {
    var slickElement = jQuery('.slider-404');
    slickElement.on('init', function () {
      jQuery(this).css('visibility', 'visible');
    });
    jQuery('.slider-404').slick({
            arrows: true, /*Стрелки навигации*/
            dots: false, /*Точки навигации*/
            autoplay: true, /*Автопрокрутка*/
            infinite: true,
            variableWidth: false,
            fade: false,
            autoplaySpeed: 5000, /*Интервал смены слайдов*/
            speed: 1000, /*Скорость анимации*/
            lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
            waitForAnimate: true, /*Ждать окончания анимации*/
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
               	{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      arrows: false
                    }
                }
            ]
        });
      }

  function pauseInactiveGalleryVideos(slider) {
    let activeSlide = slider.querySelector(".swiper-slide-active");

    slider.querySelectorAll("video.product__video").forEach(function(video) {
      if (!activeSlide || !activeSlide.contains(video)) {
        video.pause();
      }
    });
  }

  function startGalleryVideo(video, videoWrapper) {
    video.muted = true;

    let playPromise = video.play();

    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function() {
        // Autoplay blocked (e.g. iOS Low Power Mode) - let the customer tap to play.
        if (videoWrapper) {
          videoWrapper.classList.add("video-interactable");
        }

        video.controls = true;
      });
    }
  }

  function playActiveGalleryVideo(slider) {
    let activeSlide = slider.querySelector(".swiper-slide-active");

    if (!activeSlide) {
      return;
    }

    activeSlide.querySelectorAll("video.product__video").forEach(function(video) {
      let videoWrapper = video.closest(".product__video-wrapper");

      if (videoWrapper) {
        videoWrapper.classList.remove("loading");
        videoWrapper.classList.add("loaded");
      }

      if (video.dataset.videoType !== "mp4" || video.dataset.videoStyle !== "muted") {
        return;
      }

      if (!video.paused) {
        return;
      }

      startGalleryVideo(video, videoWrapper);
    });
  }

  function primeGalleryVideos(slider) {
    // iOS Safari keeps a poster-less video element blank until it actually plays, so
    // the first swipe to a video slide briefly shows the empty wrapper (a light
    // "white" flash) while the first frame decodes. Kick each muted mp4 off once
    // up front to force that frame to render, then pause the ones that aren't
    // visible yet so they sit on the decoded first frame, ready for the swipe.
    slider.querySelectorAll("video.product__video").forEach(function(video) {
      if (video.dataset.videoType !== "mp4" || video.dataset.videoStyle !== "muted") {
        return;
      }

      video.muted = true;

      let playPromise = video.play();

      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(function() {
            if (!video.closest(".swiper-slide-active")) {
              // It has rendered a frame now, so park it back at the start. The
              // priming run plays for a moment before this resolves; resetting
              // currentTime means the swipe starts playback from the beginning
              // instead of a couple of seconds in.
              video.pause();
              video.currentTime = 0;
            }
          })
          .catch(function() {
            // Autoplay blocked (e.g. iOS Low Power Mode) - leave it for the tap fallback.
          });
      }
    });
  }

  if (window.Swiper) {
    document.querySelectorAll('.swiper-product-page').forEach(function(slider) {
      if (slider.swiper) {
        return;
      }

      new Swiper(slider, {
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 0,
        threshold: 6,
        touchAngle: 45,
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true
        },
        on: {
          init: function(swiper) {
            primeGalleryVideos(swiper.el);
            playActiveGalleryVideo(swiper.el);
          },
          slideChangeTransitionStart: function(swiper) {
            // Mirror production's Slick `beforeChange`: pause the outgoing video
            // and start the incoming one as the transition begins. Kicking it off
            // now gives iOS the length of the animation to decode and paint the
            // first frame, so the slide never lands on an empty white box.
            pauseInactiveGalleryVideos(swiper.el);
            playActiveGalleryVideo(swiper.el);
          },
          slideChangeTransitionEnd: function(swiper) {
            pauseInactiveGalleryVideos(swiper.el);
            playActiveGalleryVideo(swiper.el);
          },
          touchEnd: function(swiper) {
            pauseInactiveGalleryVideos(swiper.el);
          }
        }
      });
    });
  }
});
jQuery(document).ready(function ($) {
  	$('.s-table-in').hide();
  	if($('.s-table-in').parent('.table-wrapper').length !== 0) {
  		$('.s-table-in').parent('.table-wrapper').hide();
    }
	$(document).on('click','.sel-cm-table,.sel-in-table',function(e){
      e.preventDefault();
      $('.sel-cm-table,.sel-in-table').removeClass('active');
      $('.s-table-cm,.s-table-in').hide();
      $('.s-table-cm,.s-table-in').parent('.table-wrapper').hide();
      if($(this).hasClass('sel-cm-table')) {
        $('.sel-cm-table').addClass('active');
        $('.s-table-cm').show();
        $('.s-table-cm').parent('.table-wrapper').show();
      }
      else if($(this).hasClass('sel-in-table')) {
        $('.sel-in-table').addClass('active');
        $('.s-table-in').show();
        $('.s-table-in').parent('.table-wrapper').show();
      }
      return false;
    });

  $(document).on('click',".mw-size-nav li a", function(e){
    e.preventDefault();
    var ctHeight = $("header").outerHeight() * 2;
    var y = document.getElementById($(this).attr("href").replace("#", "")).getBoundingClientRect().top + window.scrollY;
    var duration = 2000;//long scroll
    var duration2 = 1000;//short scroll
    if(($(this).attr("href") === "#menswear" && $(this).closest(".mw-size-nav").hasClass("mw-bottom")) || ($(this).attr("href") === "#womenswear" && !$(this).closest(".mw-size-nav").hasClass("mw-bottom"))) {
      duration = duration2;
    }
    if($(this).closest(".mw-size-nav").hasClass("mw-bottom") && $(this).attr("href") === "#menswear") {
      return false;
    }
    $("html, body").stop().animate({ scrollTop: $($(this).attr("href")).offset().top - ctHeight }, duration, "swing");
    return false;
  });

  $(document).on('change', '.cb-label [name=form_tags]', function() {
    var input = $("#ct_val");
    var newVal = "";
    input.val("");
    var index = 0;
    $(".cb-label [name=form_tags]").each(function() {
      if($(this).prop("checked")) {
        if(index !== 0) {
          newVal += ",";
        }
        newVal += $(this).val();
		index++;
      }
    });
    input.val(newVal);
  });
});
